import moment from "moment/moment";
import pluralize from "pluralize";

export const truncate = (text, stop, clamp) => {
  if (!text) {
    return "";
  }
  return text.slice(0, stop) + (stop < text.length ? clamp || "..." : "");
};

/**
 * @deprecated Use formatDate from @/utils/dateUtils instead
 * INFO - VR - 05/01/2026 - RTEC-1533 - This function is deprecated and will be removed in a future version
 * Moved to dateUtils.js for better organization (date utilities should be grouped together)
 */
export const formatDate = (value, activeHours = true, separator = "/") => {
  if (!value) {
    return;
  }
  if (value instanceof Date) {
    value = value.toISOString();
  }
  if (activeHours) {
    return moment(String(value)).format(`DD${separator}MM${separator}YYYY HH:mm`);
  } else {
    return moment(String(value)).format(`DD${separator}MM${separator}YYYY`);
  }
};

export const middleTruncate = (text, stop, clamp) => {
  if (text.length <= stop) {
    return text;
  }
  clamp = clamp || "...";
  let sepLen = clamp.length;
  let charsToShow = stop - sepLen;
  let frontChars = Math.ceil(charsToShow / 2);
  let backChars = Math.floor(charsToShow / 2);
  return text.substr(0, frontChars) + clamp + text.substr(text.length - backChars);
};

/**
 * @deprecated Use formatFileSize from @/utils/fileUtils instead
 * INFO - VR - 22/12/2025 - RTEC-1533 - This function is deprecated and will be removed in a future version
 */
export const getFormattedSize = (bytes, decimals) => {
  if (bytes === 0) {
    return "0 Byte";
  }
  let k = 1024;
  let dm = decimals <= 0 ? 0 : decimals || 2;
  let sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
  let i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
};

export const lowercase = (value) => {
  if (value) {
    value = value.toString();
    return value.toLowerCase();
  }
};

export const uppercase = (value) => {
  if (value) {
    value = value.toString();
    return value.toUpperCase();
  }
};

export const capitalize = (value) => {
  if (!value) return "";
  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1);
};

export const thousandFormat = (value) => {
  if (value == 0) return "0";
  if (!value) return "";
  return value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
};

export const formatAmount = (amount) => {
  const parsedAmount = parseFloat(amount);
  if (parsedAmount >= 10000) {
    let thousands = Math.floor(parsedAmount / 1000);
    return new Intl.NumberFormat("fr-FR").format(thousands) + "K";
  }
  return parsedAmount.toFixed(2).replace(".", ",");
};

export { pluralize };
